import { FILTER_OPS_BY_TYPE, type FilterOp } from '@servicetim/shared';
import type { CatalogFieldType } from '../catalog/field-catalog';

export type OpShape = 'none' | 'scalar' | 'array' | 'range';

const ARRAY_OPS: ReadonlySet<FilterOp> = new Set(['in', 'not_in', 'any_of', 'all_of', 'none_of']);
const NO_VALUE_OPS: ReadonlySet<FilterOp> = new Set(['is_null', 'not_null']);

/** Ops whose value is free text whatever the field type. */
export const TEXT_OPS: ReadonlySet<FilterOp> = new Set(['contains', 'starts_with', 'search']);

export function opShape(op: FilterOp): OpShape {
  if (NO_VALUE_OPS.has(op)) return 'none';
  if (ARRAY_OPS.has(op)) return 'array';
  if (op === 'between') return 'range';
  return 'scalar';
}

export const OP_LABELS: Record<FilterOp, string> = {
  eq: 'is',
  neq: 'is not',
  in: 'is any of',
  not_in: 'is none of',
  gt: 'greater than',
  gte: 'at least',
  lt: 'less than',
  lte: 'at most',
  between: 'between',
  is_null: 'is empty',
  not_null: 'is not empty',
  contains: 'contains',
  starts_with: 'starts with',
  any_of: 'has any of',
  all_of: 'has all of',
  none_of: 'has none of',
  search: 'matches search',
};

/** Operators the registry allows for a field type (`text` search only accepts `search`). */
export function opsForType(type: CatalogFieldType | undefined): readonly FilterOp[] {
  if (type === undefined) return [];
  if (type === 'text_search') return ['search'];
  return FILTER_OPS_BY_TYPE[type];
}

/** Keeps a value only when the operator shape did not change (scalar to scalar, array to array). */
export function carryValue(from: FilterOp, to: FilterOp, value: unknown): unknown {
  return opShape(from) === opShape(to) ? value : undefined;
}
